// extracted by mini-css-extract-plugin
export default {"opener":"MezzaDetailOpener_opener__jrdJ8"};